<template>
  <div class="travelRelatedPersonnel">
      <!-- 涉旅人员详情页 -->
      <div class="wrapper-box">
        <listItem :label="'涉旅人员姓名'" :labelWidth="134" :ctnColor="'#333333'" :showRight="false">{{relatedPersonData.name}}</listItem>
        <rline></rline>
        <listItem :label="'涉旅人员证件类型'" :labelWidth="134" :ctnColor="'#333333'" :showRight="false">{{relatedPersonData.certType}}</listItem>
        <rline></rline>
        <listItem :label="'涉旅人员证件号码'" :labelWidth="134" :ctnColor="'#333333'" :showRight="false">{{relatedPersonData.certNum}}</listItem>
      </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                relatedPersonData: {}
            };
        },

        computed: {},

        watch: {},

        methods: {
        },

        mounted () {
            if (localStorage.travelRelatedPersonData) {
                this.relatedPersonData = JSON.parse(localStorage.travelRelatedPersonData)
            }
        },
        created () {}
    };
</script>
<style scoped lang="less">
.travelRelatedPersonnel {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-top: 16px;
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px;
    overflow: hidden;
    margin-bottom: 12px;
  }
}
</style>
